import { $api } from "../AxiosInstance";

export class SettingsService {
  /**
   * Get ASES email settings
   */
  static async settingsASES() {
    return await $api.get(`/api/admin/settings/email/ases`);
  }

  /**
   * Get SMTP email settings
   */
  static async settingsSMTP() {
    return await $api.get(`/api/admin/settings/email/smtp2go`);
  }

  /**
   * Get active mail service
   */
  static async getActiveMailService() {
    return await $api.get(`/api/admin/settings/email/general`);
  }

  /**
   * Set active mail service
   * @param {Object} params
   */
  static async setActiveMailService(params) {
    return await $api.post(`/api/admin/settings/email/general`, params);
  }

  /**
   * Save ASES email settings
   * @param {Object} params
   */
  static async settingsASESSave(params) {
    return await $api.post(`/api/admin/settings/email/ases`, params);
  }

  /**
   * Save SMTP email settings
   * @param {Object} params
   */
  static async settingsSMTPSave(params) {
    return await $api.post(`/api/admin/settings/email/smtp2go`, params);
  }

  /**
   * Full initialization of settings
   */
  static async settingsFullInit() {
    return await $api.post(`/api/settings/full-init`);
  }

  /**
   * Clear cache
   */
  static async settingsClearCache() {
    return await $api.get(`/api/front/clear/cache`);
  }

  /**
   * Get user balance setting
   */
  static async getUserBalanceSetting() {
    return await $api.get("/api/admin/settings/balance");
  }

  /**
   * Set user balance setting
   * @param {Object} params
   */
  static async setUserBalanceSetting(params) {
    return await $api.post("/api/admin/settings/balance", params);
  }

  /**
   * Get Telegram settings
   */
  static async getTelegramSetting() {
    return await $api.get("/api/admin/settings/telegram");
  }

  /**
   * Set Telegram settings
   * @param {Object} params
   */
  static async setTelegramSetting(params) {
    return await $api.post("/api/admin/settings/telegram", params);
  }

  /**
   * Get WhatsApp settings
   */
  static async getWhatsAppSetting() {
    return await $api.get("/api/admin/settings/whatsApp");
  }

  /**
   * Set WhatsApp settings
   * @param {Object} params
   */
  static async setWhatsAppSetting(params) {
    return await $api.post("/api/admin/settings/whatsApp", params);
  }

  /**
   * Get Paddle subscription config
   */
  static async getPaddleSubscriptionConfig() {
    return await $api.get("/api/admin/settings/paddle/subscription");
  }

  /**
   * Set Paddle subscription config
   * @param {Object} params
   */
  static async setPaddleSubscriptionConfig(params) {
    return await $api.post("/api/admin/settings/paddle/subscription", params);
  }

  /**
   * Get PipeDrive settings
   */
  static async getPipeDriveSetting() {
    return await $api.get("/api/admin/settings/pipedrive");
  }

  /**
   * Set PipeDrive settings
   * @param {Object} params
   */
  static async setPipeDriveSetting(params) {
    return await $api.post("/api/admin/settings/pipedrive", params);
  }

  static async getLumeniqSetting() {
    return await $api.get("/api/admin/settings/lumeniq");
  }

  static async setLumeniqSetting(params) {
    return await $api.post("/api/admin/settings/lumeniq", params);
  }

  /**
   * Get validate email settings
   */
  static async getValidateEmailSetting() {
    return await $api.get("/api/admin/settings/email/checker");
  }

  /**
   * Set validate email settings
   * @param {Object} params
   */
  static async setValidateEmailSetting(params) {
    return await $api.post("/api/admin/settings/email/checker", params);
  }

  /**
   * Get type proxies settings
   */
  static async getTypeProxiesSettings() {
    return await $api.get(`/api/admin/settings/proxyTypes`);
  }

  /**
   * Set type proxies settings
   * @param {Object} params
   */
  static async setTypeProxiesSettings(params) {
    return await $api.post(`/api/admin/settings/proxyTypes`, params);
  }

  /**
   * Get goals settings
   */
  static async getGoalsSettings() {
    return await $api.get(`/api/admin/settings/project`);
  }

  /**
   * Set goals settings
   * @param {Object} params
   */
  static async setGoalsSettings(params) {
    return await $api.post(`/api/admin/settings/project`, params);
  }

  /**
   * Get captcha key
   */
  static async getCaptchaKey() {
    return await $api.get("/api/captcha/key");
  }

  /**
   * Get captcha settings
   */
  static async getCaptchaSettings() {
    return await $api.get("/api/admin/settings/google/captcha");
  }

  /**
   * Get Cloudflare captcha settings
   */
  static async getCfCaptchaSettings() {
    return await $api.get("/api/admin/settings/cloud/captcha");
  }

  /**
   * Save Cloudflare captcha settings
   * @param {Object} params
   */
  static async saveCfCaptchaSettings(params) {
    return await $api.post("/api/admin/settings/cloud/captcha", params);
  }

  /**
   * Save captcha settings
   * @param {Object} params
   */
  static async saveCaptchaSettings(params) {
    return await $api.post("/api/admin/settings/google/captcha", params);
  }

  /**
   * Get GA4 analytics settings
   */
  static async getGa4analiticsSettings() {
    return await $api.get("/api/admin/settings/ga4");
  }

  /**
   * Save GA4 analytics settings
   * @param {Object} params
   */
  static async saveGa4analiticsSettings(params) {
    return await $api.post("/api/admin/settings/ga4", params);
  }

  /**
   * Get CRM settings
   */
  static async getCRMSettings() {
    return await $api.get("/api/admin/settings/crm");
  }

  /**
   * Save CRM settings
   * @param {String} proxy_CRM_host_prod
   * @param {String} proxy_CRM_host_stage
   * @param {Boolean} processing_change_host_status
   * @param {Number} proxy_CRM_proxy_port
   * @param {Number} proxy_CRM_socks_port
   * @param {Boolean} proxy_CRM_test_mode
   * @param {String} token_proxy_crm_prod
   * @param {String} token_proxy_crm_stage
   * @param {Boolean} proxy_CRM_connect
   * @param {Boolean} crm_webhook_verification
   */
  static async saveCRMSettings(
    proxy_CRM_host_prod,
    proxy_CRM_host_stage,
    processing_change_host_status,
    proxy_CRM_proxy_port,
    proxy_CRM_socks_port,
    proxy_CRM_test_mode,
    token_proxy_crm_prod,
    token_proxy_crm_stage,
    proxy_CRM_connect,
    crm_webhook_verification
  ) {
    return await $api.post("/api/admin/settings/crm", {
      proxy_CRM_host_prod,
      proxy_CRM_host_stage,
      processing_change_host_status,
      proxy_CRM_proxy_port,
      proxy_CRM_socks_port,
      proxy_CRM_test_mode,
      token_proxy_crm_prod,
      token_proxy_crm_stage,
      proxy_CRM_connect,
      crm_webhook_verification: !!crm_webhook_verification,
    });
  }

  /**
   * Get company email settings
   */
  static async getCompanyEmailSettings() {
    return await $api.get("/api/admin/settings/emailCompanySettings");
  }

  /**
   * Save company email settings
   * @param {Object} params
   */
  static async saveCompanyEmailSettings(params) {
    return await $api.post("/api/admin/settings/emailCompanySettings", params);
  }

  /**
   * Get header tags settings
   */
  static async getHeaderTagsSettings() {
    return await $api.get("/api/admin/settings/headerTagsSettings");
  }

  /**
   * Save header tags settings
   * @param {String} text
   */
  static async saveHeaderTagsSettings(text) {
    return await $api.post("/api/admin/settings/headerTagsSettings", {
      text,
    });
  }

  /**
   * Get body tags settings
   */
  static async getBodyTagsSettings() {
    return await $api.get("/api/admin/settings/bodyTagsSettings");
  }

  /**
   * Save body tags settings
   * @param {String} text
   */
  static async saveBodyTagsSettings(text) {
    return await $api.post("/api/admin/settings/bodyTagsSettings", {
      text,
    });
  }

  /**
   * Get new design enabled status
   */
  static async getNewDesignEnabled() {
    return await $api.post("/api/settings/main/get");
  }

  /**
   * Set new design enabled status
   * @param {Object} params
   */
  static async setNewDesignEnabled(params) {
    return await $api.post("/api/settings/main/set", params);
  }

  /**
   * Get debug settings
   */
  static async getDebagger() {
    return await $api.get("/api/admin/settings/debug");
  }

  /**
   * Set debug settings
   * @param {Object} params
   */
  static async setDebagger(params) {
    return await $api.post("/api/admin/settings/debug", params);
  }

  /**
   * Get V2 autoextend system settings
   */
  static async getV2AutoextendSystemSettings() {
    return await $api.get("/api/admin/settings/autoextendV2");
  }

  /**
   * Get hide country settings
   */
  static async getHideCountrySettings() {
    return await $api.get("/api/admin/settings/country");
  }

  /**
   * Set V2 autoextend system settings
   * @param {Object} params
   */
  static async setV2AutoextendSystemSettings(params) {
    return await $api.post("/api/admin/settings/autoextendV2", params);
  }

  /**
   * Set hide country settings
   * @param {Object} params
   */
  static async setHideCountrySettings(params) {
    return await $api.post("/api/admin/settings/country", params);
  }

  /**
   * Get web notifications settings
   */
  static async getWebNotificationsSettings() {
    return await $api.get("/api/admin/settings/website/notifications");
  }

  /**
   * Set web notifications settings
   * @param {Object} params
   */
  static async setWebNotificationsSettings(params) {
    return await $api.post("/api/admin/settings/website/notifications", params);
  }

  /**
   * Get socket process settings
   */
  static async getSocketProcess() {
    return await $api.get("/api/admin/settings/payment/socket/process");
  }

  /**
   * Set socket process settings
   * @param {Object} params
   */
  static async setSocketProcess(params) {
    return await $api.post("/api/admin/settings/payment/socket/process", params);
  }
}
